import { render, staticRenderFns } from "./IconClipboardCopyOutline.vue?vue&type=template&id=08749f1e"
import script from "./IconClipboardCopyOutline.vue?vue&type=script&lang=js"
export * from "./IconClipboardCopyOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports